import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Companies from "@/pages/Companies";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Portfolio from "@/pages/Portfolio";
import CaseStudies from "@/pages/CaseStudies";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";


function Wrap({ children }) {
  return <SiteLayout>{children}</SiteLayout>;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<Wrap><Home /></Wrap>} />
            <Route path="/about" element={<Wrap><About /></Wrap>} />
            <Route path="/companies" element={<Wrap><Companies /></Wrap>} />
            <Route path="/services" element={<Wrap><Services /></Wrap>} />
            <Route path="/industries" element={<Wrap><Industries /></Wrap>} />
            <Route path="/portfolio" element={<Wrap><Portfolio /></Wrap>} />
            <Route path="/case-studies" element={<Wrap><CaseStudies /></Wrap>} />
            <Route path="/resources" element={<Wrap><Resources /></Wrap>} />
            <Route path="/contact" element={<Wrap><Contact /></Wrap>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<Wrap><Home /></Wrap>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
